// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"checkbox__wrapper-3Rypw","checkbox":"checkbox__checkbox-5tfMb","title":"checkbox__title-1H2QJ","label":"checkbox__label-2cfnX"};


//////////////////
// WEBPACK FOOTER
// ./~/account-ui/checkbox/checkbox.css
// module id = 857
// module chunks = 0